import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.contrastText,
    borderRadius: 10,
    borderWidth: "1px",
  },
  "& .MuiInputLabel-root.Mui-disabled": {
    color: theme.palette.primary.contrastText,
  },
  "& .MuiInputBase-input": {
    color: theme.palette.primary.contrastText,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: theme.palette.primary.contrastText,
    "-webkit-text-fill-color": theme.palette.primary.contrastText,
  },
  "& .MuiOutlinedInput-root": {
    "& textarea": {
      overflow: "hidden",
    },
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.light,
     borderWidth: "1px",
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.primary.contrastText,
     borderWidth: "1px",
  },
}));

interface IssueReportTextFieldProps {
  title: string;
  value?: string;
  numsRows?: number;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const IssueReportTextField = (props: IssueReportTextFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(e.target.value);
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <CustomTextField
        label={props.title}
        value={props.value}
        onChange={handleChange}
        variant="outlined"
        multiline
        rows={props.numsRows || 1}
        fullWidth
        type="text"
        disabled={props.disabled}
        InputLabelProps={{ shrink: true }}
      />
    </div>
  );
};

export default IssueReportTextField;
